module.exports = __webpack_public_path__ + "static/media/naturaBrand.4a9c501e.svg";